<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="loading"></b-loading>

        <div class="columns is-multiline" style="border-bottom:#ddd 0.8px solid;">
            <div class="column is-full">
                <b-field label="Display en home">
                    <b-switch
                    v-model="section.display">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Titulo">
                    <b-input
                    required
                    expanded
                    v-model="section.title"
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Texto">
                    <b-input
                    type="textarea"
                    expanded
                    v-model="section.text">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                :loading="updateLoad"
                @click="updateSection">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Save section info
                </b-button>
            </div>
        </div>

        <div class="columns is-multiline is-centered m-t-30">
            <div v-if="cards.length > 0" v-for="(x, i) in cards" 
            :key="x.id"
            :index="i"
            class="column is-one-third has-text-centered m-b-30">
                
                <img :src="x.image" class="supplier">
                <p class="title is-size-6">
                    <span>
                    <a class="has-text-danger"
                    @click="deleteCard({isNew:false, index:x.id})">
                        <b-icon icon="trash" size="is-small"></b-icon>
                    </a>
                </span>
                    {{x.title}}
                </p>
                <p class="title is-size-5">{{x.clientWebsite}}</p>
            </div>
            <div v-if="!cards.length"
                class=" column is-full has-text-centered">
                <h2 class="title is-size-3">
                    Looks like you need to add some suppliers!
                </h2>
            </div>
            <div class="column has-text-centered is-full m-t-30">
                <b-button
                type="is-primary"
                rounded
                @click="addModal = true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Add some new suppliers
                </b-button>
            </div>
        </div>


        <b-modal :active.sync="addModal"  scroll="keep">
            <div class="modal-card" style="width: auto">

                <div class="modal-card-body">
                    <SupplierElement
                    v-for="(x, i) in newCards"
                    :isNew="true"
                    :key="i"
                    :data="x"
                    :index="i"
                    @deleteElement="deleteCard"
                    />

                    <div class="columns is-multiline">
                        <div class="column is-full has-text-left">
                            <b-button
                            type="is-light"
                            rounded
                            @click="pushNewCard">
                                <b-icon icon="plus" size="is-small"></b-icon>
                               Agregar linea
                            </b-button>
                        </div>

                        <div class="column is-full has-text-centered">
                            <b-button
                            type="is-primary"
                            rounded
                            @click="createNewCards">
                                <b-icon icon="save" size="is-small"></b-icon>
                                Crear neuvo proveedor
                            </b-button>
                        </div>
                        
                    </div>

                </div>

                
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getHandler, patchHandler, deleteHandler, postHandler } from '../../../../services/http';
import SupplierElement from "./SupplierElement.vue"

export default {
    props:{
        supplierList:{
            type:String,
            default:""
        },
        supplierCreate:{
            type:String,
            default:""
        },
        supplierDetail:{
            type:String,
            default:""
        },
        supplierSectionDetail:{
            type:String,
            default:""
        }
    },
    components:{
        SupplierElement
    },
    data(){
        return{
            loading:false,
            updateLoad:false,
            cards:[],
            newCards:[
                {
                    clientWebsite:"",
                    title:"",
                    image:""
                },
            ],
            createLoad:false,
            section:{},
            addModal:false
        }
    },
    methods:{
        async fetchCards(){
            this.loading = true
            this.cards = await getHandler(this.supplierList, {error:false, success:false})
            console.log(this.cards)
            this.loading = false
        },
        async fetchSection(){
            this.loading = true
            this.section = await getHandler(this.supplierSectionDetail,{error:false, success:false} )
            this.loading = false
        },
        async updateSection(){
            let msg = {
                resource:'notify'
            }
            this.updateLoad = true
            this.section = await patchHandler(this.supplierSectionDetail, this.section, {error:msg, success:msg})
            this.fetchSection()
            this.updateLoad = false
        },
        async deleteCard(payload){
            if(payload.isNew){
                this.newCards.splice(payload.index, 1)
            } else{
                let msg = {
                    resource:"notify"
                }
                let url = this.supplierDetail.replace('0000', payload.index)
                let resp = await deleteHandler(url, {error:msg, success:msg})
                this.fetchCards()
            }
        },
        async createNewCards(){
            this.createLoad = true
            let msg = {
                resource:"notify"
            }
            let resp = await postHandler(this.supplierCreate, this.newCards, {error:msg, success:msg})
            this.newCards = [
                {
                    clientWebsite:"",
                    title:"",
                    image:""
                },
            ]
            this.fetchCards()
            this.createLoad = false
        },
        pushNewCard(){
            this.newCards.push({
                clientWebsite:"",
                title:"",
                image:""
            })
        }
    },
    created(){
        this.fetchCards()
        this.fetchSection()
    }
}
</script>

<style lang="scss" scoped>
.supplier{
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>
